import loadable from '@loadable/component';

export const AnimatedIconLoadable = loadable(() => import('./AnimatedIcon'), {
  resolveComponent: (module) => module.AnimatedIcon,
});
